import { getDefaultHeaders, setCsrfToken } from "./utils";

export async function comicSeriesPost(data) {
  let headers = await getDefaultHeaders(true, true);
  const requestOptions = {
    method: "POST",
    headers: headers,
    body: JSON.stringify(data),
  };
  const url = "/api/comic-series/";
  try {
    const response = await fetch(url, requestOptions);
    const jsonResponse = await response.json();
    if (response.status === 403 && jsonResponse.detail.includes("CSRF Failed")) {

      await setCsrfToken();
      return await comicSeriesPost(data)
    }
    return jsonResponse;
  } catch (err) {
    console.log("ERROR 1", err);
    return [];
  }
}
